/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Help_ChoosingInputs */

const en_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need help choosing? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">Starter vs. Pro Comparison</a>`)
};

const fr_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Besoin d'aide pour choisir ? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">Comparaison Débutant vs. Pro</a>`)
};

const de_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brauchen Sie Hilfe bei der Auswahl? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">Vergleich Starter vs. Pro</a>`)
};

const it_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hai bisogno di aiuto per scegliere? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">Confronto tra Starter e Pro</a>`)
};

const ru_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нужна помощь в выборе? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">Сравнение версий Starter и Pro</a>`)
};

const es_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Necesitas ayuda para elegir? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">Comparativa de Starter vs. Pro</a>`)
};

const zh_cn2_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`需要帮助选择？<a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">入门版与专业版对比</a>`)
};

const ja_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択にお困りですか？<a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">スターターとプロの比較</a>`)
};

const hi_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयन में सहायता चाहिए? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">स्टार्टर बनाम प्रो तुलना</a>`)
};

const pt_pt2_signup_help_choosing = /** @type {(inputs: Signup_Help_ChoosingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Precisa de ajuda para escolher? <a target="_blank" href="https://www.closedcaptioncreator.com/features/index.html" class="link-accent">Comparação entre versões Starter e Pro</a>`)
};

/**
* | output |
* | --- |
* | "Need help choosing? <a target=\"_blank\" href=\"https://www.closedcaptioncreator.com/features/index.html\" class=\"link-accent\">Starter vs. Pro Comparison</a>" |
*
* @param {Signup_Help_ChoosingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const signup_help_choosing = /** @type {((inputs?: Signup_Help_ChoosingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Help_ChoosingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_signup_help_choosing(inputs)
	if (locale === "de") return de_signup_help_choosing(inputs)
	if (locale === "it") return it_signup_help_choosing(inputs)
	if (locale === "ru") return ru_signup_help_choosing(inputs)
	if (locale === "es") return es_signup_help_choosing(inputs)
	if (locale === "zh-CN") return zh_cn2_signup_help_choosing(inputs)
	if (locale === "ja") return ja_signup_help_choosing(inputs)
	if (locale === "hi") return hi_signup_help_choosing(inputs)
	if (locale === "pt-PT") return pt_pt2_signup_help_choosing(inputs)
	return en_signup_help_choosing(inputs)
});